import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { InventoryThumbnailImage } from 'site-modules/inventory/components/inventory-thumbnails/inventory-thumbnail-image';
import './inventory-thumbnail.scss';

export function InventoryThumbnail({ url, title, onClick = noop, vin, bodyType }) {
  return (
    <div className="inventory-thumbnail">
      <AspectRatioContainer aspectRatio="15:9" className="border-8">
        <button
          className="w-100 h-100 border-0 p-0"
          aria-label={`${title}, View more photos`}
          onClick={onClick}
          aria-haspopup="dialog"
        >
          <InventoryThumbnailImage url={url} vin={vin} bodyType={bodyType} />
        </button>
      </AspectRatioContainer>
    </div>
  );
}

InventoryThumbnail.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  vin: PropTypes.string.isRequired,
  bodyType: PropTypes.string.isRequired,
};
